export enum RbacModules {
  user = 'user',
  team = 'team',
  queue = 'queue',
  skill = 'skill',
  businessHour = 'business_hour',
  transferDestination = 'transfer_destination',
  destination = 'destination',
  channelCalls = 'call_channel',
  channelChats = 'chat_channel',
  channelWhatsapp = 'whatsapp_channel',
  channelMessage = 'message_channel',
  channelEmail = 'email_channel',
  billing = 'billing',
  holiday = 'holiday',
  agentStatus = 'agent_status',
  workloadAccessAgent = 'routing_setting', // In BE this is still routing_setting
  transferSetting = 'transfer_setting',
  workloadAccessConversations = 'disposition', // In BE this is still disposition
  orgSetting = 'org_setting',
  integration = 'integration',
  connectedApps = 'connected_apps',
  report = 'report',
  convCallAndRecordings = 'conv_calls_and_recordings',
  liveConversation = 'active_conversation_view',
  monitorAndBargeConv = 'monitor_and_barge_conv',
  aiAgent = 'flow',
  cdp = 'cdp',
  logs = 'logs',
  ucc = 'ucc',
  apiCredentials = 'api_credentials',
  // Below constants are for future use
  knowledgeBase = 'knowledge_base',
  knowledgeBaseCategory = 'knowledge_base_category',
  knowledgeBaseArticle = 'knowledge_base_article',
}

export enum RbacPermissionTypes {
  view = 'view',
  viewPii = 'view_pii',
  create = 'create',
  edit = 'edit',
  delete = 'delete',
  publish = 'publish',
  monitor = 'monitor_conversation',
  bargein = 'bargein_conversation',
  downloadCallRecording = 'download_call_recording',
  downloadConversation = 'download_conversation',
  downloadConversationList = 'download_conversation_list',
}

export enum RbacPermissionLevels {
  org = 'org',
  team = 'team',
  peer = 'peer',
  self = 'self',
}

export type ModulePermissionTypeMap = {
  [module in RbacModules]?: {
    [type in RbacPermissionTypes]?: boolean
  }
}
